import { useAuthStore } from '../auth/useAuthStore';
import './client-portal.css';

/**
 * Sesión válida, pero sin la entitlement del portal. Nunca implica que la
 * cuenta no exista — solo que no está habilitada para este contexto.
 */
export function ClientPortalAccessDenied(): JSX.Element {
  const { logout } = useAuthStore();

  return (
    <div className="portal-denied">
      <h1>No tenés acceso a este portal</h1>
      <p>Tu cuenta es válida, pero no está habilitada para este espacio.</p>
      <button onClick={() => logout()}>Cerrar sesión</button>
    </div>
  );
}
